import React, { Fragment } from 'react';

import SectionSeparator from '@dashboard/components/SectionSeparator';
import { useWorkflowEventQuery } from '@dashboard/generated/wp/platform';

import StepCard from './StepCard';
import TimelineHeader from './TimelineHeader';
import TriggerCard from './TriggerCard';

type Props = {
  id: string;
};
export default function Body({ id }: Props) {
  const { data } = useWorkflowEventQuery({
    pollInterval: 3000,
    variables: { id },
  });
  const model = data?.WorkflowEvent;

  if (model === undefined) {
    return null;
  }

  return (
    <>
      <TimelineHeader id={id} />
      <TriggerCard id={id} />
      {model.steps.map((step, i) => (
        <Fragment key={i}>
          <SectionSeparator />
          <StepCard step={step!} />
        </Fragment>
      ))}
    </>
  );
}
